export const getDefaultState = () => {
  return {
    searchResults: [],
    unitUptakeInsights: [],
    showInsights: false,
    selectedInsightId: null
  };
};

export default {
  ...getDefaultState()
};
